import React, { useState } from "react";
import { RWebShare } from "react-web-share";
import { shareWebIcon } from "../../pages/createEvent/page/SelectMesaType/components/svgIcons";

const ReactWebShare = ({data}) => {
  return (
    <RWebShare
        // data={{
        //   text: "Like humans, flamingos make friends for life",
        //   url: "https://on.natgeo.com/2zHaNup",
        //   title: "Flamingos",
        // }}
        data={data}
        onClick={() => console.log("shared successfully!")}
        sites ={["facebook", "twitter","whatsapp"]}
      >
        {/* <i className="iClass icon-share" aria-hidden="true" /> */}
         <span dangerouslySetInnerHTML={{__html: shareWebIcon}} className='share-web-gift-list-icon-wap' />
      </RWebShare>
  );
};

export default ReactWebShare;